<template>
  <ul class="ushk-rili_list-wrap J_rili_listItem">
    <li class="ushk-rili_list-empty" v-if="!datas || !datas.length">
      <img src="//cdn.jin10.com/assets/img/sites/rili/empty_event.png">
      <p>{{ !datas ? '加载中......' : '今日无财经大事' }}</p>
    </li>
    <li v-for="(data, index) in datas" class="ushk-rili_list-item">
      <div class="ushk-rili_list-country">
        <img :src="`//cdn.jin10.com/assets/img/commons/flag/flash/${data.country}.png`">
      </div>
      <div class="ushk-rili_list-body">
        <div class="ushk-rili_list-h">
          <div class="ushk-rili_list-time">
            <i class="ushk-icon ushk-icon_time"></i>
            <span>{{ data.public_time }}</span>
          </div>
          <star :width="data.star"/>
        </div>
        <h3 class="ushk-rili_list-title">{{ data.eventcontent }}</h3>
      </div>
      <div class="ushk-rili_list-tag">
        <p class="ushk-btn ushk-btn_plain-primary">
          <i class="ushk-icon ushk-icon_time"></i>
          <span>{{ data.public_time }}</span>
        </p>
      </div>
    </li>
  </ul>
</template>

<script>
  export default {
    props: {
      datas: {
        type: [Array, Boolean],
        default: false
      }
    },
    data () {
      return {}
    }
  }
</script>



// WEBPACK FOOTER //
// EventsList.vue?7033e4f2